import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";
import MRINDIANCODER from "../images/mr.indiancoder.jpg";


function Footer() {
  return (

    <div className="umastyle">
      <br></br>
      <br />

      <div className="album py-3">

        <div className="container">

          <div className="row">
            <div className="col-md-4">

              <h6>UMA HARDWARE</h6>
              <hr />
              <ul className="list-unstyled">
                <h6 className="card-text">Showroom Address</h6>
                <p className="card-text mb-2">NATNA, KARIMPUR<br /> NADIA,  WEST BENGNA - 741122</p>
                
                    <p>  <a href="tel: +91 9932338173"  className="btn btn- btn-outline-light">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>
</svg> +91 9932338173</a></p>
                           <p>  <a href="tel: +91 9733722023"  className="btn btn- btn-outline-light">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>
</svg> +91 9733722023</a></p>
<p className=" card-text mb-1">
<a href="tel: +91 9732645675"  className="btn btn- btn-outline-light">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>
</svg>  +91 9732645675</a></p>
                <p className="card-text mb-2"> <br />Copyright © Uma Hardware</p>




              </ul>
            </div>

            <div className="col-md-2">
              <h6>KAJARIA</h6>
              <hr />
              <ul class="list-unstyled">
                <Link style={{ color: "white" }} to="/Kajaria" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" ><small>Kajaria Bedroom Tiles</small></li></Link>
                <Link style={{ color: "white" }} to="/KajariaKitchenwall" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" > <small>Kajaria Kitchen Wall Tiles</small></li>
                </Link>



              </ul>
            </div>
            <div className="col-md-2">
              <h6>PRODUCT</h6>
              <hr />
              <ul className="list-unstyled">
                <Link style={{ color: "white" }} to="/Johnson" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" > <small>Johnson</small></li>
                </Link>

                <Link style={{ color: "white" }} to="/Orientbell" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" > <small>Orientbell</small></li>
                </Link>
                <Link style={{ color: "white" }} to="/Somany" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" > <small>Somany</small></li>
                </Link>
                <Link to="/Jaquar" target="_blank" rel="noopener noreferrer">

                  <li className="mb-2" style={{ color: "white" }} > <small>Jaquar</small></li>
                </Link>
                <Link to="/Dulux" target="_blank" rel="noopener noreferrer">

                  <li className="mb-2" style={{ color: "white" }} > <small>Dulux</small></li>
                </Link>
                <Link to="/Coto" target="_blank" rel="noopener noreferrer">
                  <li style={{ color: "white" }} className="mb-2" > <small>Coto</small></li>
                </Link>
                <Link to="/Finolex" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" style={{ color: "white" }}> <small>Finolex</small></li>
                </Link>


              </ul>
            </div>
            <div className="col-md-2">
              <h6>CONTACT</h6>
              <hr />
              <ul className="list-unstyled">
                <Link to="/Contact" target="_blank" rel="noopener noreferrer">
                  <li className="mb-2" style={{ color: "white" }}><small>Contact Us</small></li></Link>



              </ul>

            </div>

            <div className="col-md-2">
              <h6>SOCIAL LINKS</h6>
              <hr />
              <ul className="list-unstyled">

                <li className="mb-2" style={{ color: "white" }}> <a style={{ color: "white" }} href="https://www.facebook.com/umahardwarekarimpur" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                  </svg> <small> Facebook</small></a> </li>




                <br />

              </ul>

            </div>



          </div>
        </div>
      </div>


<center>
                <button className="btn btn-light"> <small> Visitor Counter </small> 
               <a href="https://www.umahardware.in/" target="_blank">
<img src="https://hitwebcounter.com/counter/counter.php?page=21484188&style=0006&nbdigits=9&type=page&initCount=45000" title="Uma Hardware" Alt="Uma Hardware"   border="0" /></a>             
                                    
                </button>
            </center>

      <div className="album py-2">

        <div className="container">

          <div className="row">
            <div className="col-md-4">

              <h4>UMA HARDWARE</h4>
            </div>
            <div className="col-md-4">
              <p> Copyright © 2026, UMA HARDWARE </p>

            </div>
            <div className="col-md-4">
              <small style={{ color: "white" }}> Developed & Design By : <a style={{ color: "white" }} href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> www.mrindiancoder.com</a> </small>
              <small>  <a href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> </a> </small>
              <a href="https://www.mrindiancoder.com/" target="_blank" rel="noopener noreferrer"> <img src={MRINDIANCODER} width="85" height="30" alt="mr.indiancoder" /> </a>
            </div>

          </div>
        </div>
      </div>
      <br />


    </div>



  );
}
export default Footer;